import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import sp from './Images/SP.gif';
import vc from './Images/VC.gif';
import pc from './Images/PC.gif';
import sg from './Images/SG.gif';
import hpe from './Images/HPE.gif';
import dn from './Images/DN.gif';
import sph from './Images/SPH.gif';
import sh from './Images/SM.gif';
import pipe from './Images/Pipe.gif';
import fp from './Images/FP.gif';
import round from './Images/RoRod.gif';
import her from './Images/HeRod.gif';
import be from './Images/BE.gif'
import or from './Images/OR.gif';
import cc from './Images/CC.gif';
import sn from './Images/SN.gif';
import sc from './Images/SquareCube.png';
import ht from './Images/Hextube.png';
import ps from './Images/PerforatedSheet.png';
import sd from './Images/STEPTO2D.png';
import sw from './Images/Screw.png';
import nu from './Images/Nuts.png';







function Rosad() {
  const navigate = useNavigate();
  const userEmail = sessionStorage.getItem('userEmail');

  useEffect(() => {
    if (!userEmail) {
      navigate('/signin');
    }
  }, [userEmail, navigate]);

  

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading" style={{ color: 'pink', fontSize: '35px' }}>ROSA-D</h2>
        <h3 className="center-heading" style={{ color: 'pink', fontSize: '35px' }}>Main Page</h3>
      </center>
      <br />
      <p>Signed in as: {userEmail}</p>
      <div className="app">
        <div className="button-container">
          <nav>
            <ul>
               <li>
                <Link to="/valvecalculation">
                  <img src={vc} className="app-img" width="230" height="150" alt="Valve Calculation" />
                </Link>
              </li><br />

              <li>
                <Link to="/pneumaticcircuit">
                  <img src={pc} className="app-img" width="230" height="150" alt="Pneumatic Circuit" />
                </Link>
              </li><br />

              <li>
                <Link to="/hydraulicpump">
                  <img src={hpe} className="app-img" width="230" height="150" alt="Hydraulic Pump" />
                </Link>
              </li><br />
              
              <li>
                <Link to="/spurgear">
                  <img src={sg} className="app-img" width="230" height="150" alt="Spur Gear" />
                </Link>
              </li><br />


               <li>
                <Link to="/spring">
                  <img src={sp} className="app-img" width="230" height="150" alt="Spring" />
                </Link>
              </li><br />


              <li>
                <Link to="/doughnut">
                  <img src={dn} className="app-img" width="230" height="150" alt="Doughnut" />
                </Link>
              </li><br />

              <li>
                <Link to="/sphere">
                  <img src={sph} className="app-img" width="230" height="150" alt="Sphere" />
                </Link>
              </li><br />
              <li>
                <Link to="/sheetmetal">
                  <img src={sh} className="app-img" width="230" height="150" alt="Sheetmetal" />
                </Link>
              </li><br />
              <li>
                <Link to="/pipe">
                  <img src={pipe} className="app-img" width="230" height="150" alt="Pipe" />
                </Link>
              </li><br />
              <li>
                <Link to="/fpipe">
                  <img src={fp} className="app-img" width="230" height="150" alt="fPipe" />
                </Link>
              </li><br />
              <li>
                <Link to="/roundrod">
                  <img src={round} className="app-img" width="230" height="150" alt="Roundrod" />
                </Link>
              </li><br />
              <li>
                <Link to="/hexrod">
                  <img src={her} className="app-img" width="230" height="150" alt="Hexrod" />
                </Link>
              </li><br />
              <li>
                <Link to="/bearing">
                  <img src={be} className="app-img" width="230" height="150" alt="Bearing" />
                </Link>
              </li><br />
               <li>
                <Link to="/oring">
                  <img src={or} className="app-img" width="230" height="150" alt="ORing" />
                </Link>
              </li><br />

             <li>
                <Link to="/customchair">
                  <img src={cc} className="app-img" width="230" height="150" alt="Bearing" />
                </Link>
              </li><br />

                <li>
                <Link to="/spraynozzel">
                  <img src={sn} className="app-img" width="230" height="150" alt="Bearing" />
                </Link>
              </li><br />
              <li>
                <Link to="/squarecube">
                  <img src={sc} className="app-img" width="230" height="150" alt="SquareCube" />
                </Link>
              </li><br />
             
              <li>
                <Link to="/hexagonaltube">
                  <img src={ht} className="app-img" width="230" height="150" alt="HexagonalTube" />
                </Link>
              </li><br />
             
             <li>
                <Link to="/PerforatedSheet">
                  <img src={ps} className="app-img" width="230" height="150" alt="PerforatedSheet" />
                </Link>
              </li><br />

              <li>
                <Link to="/StepTo2D">
                  <img src={sd} className="app-img" width="230" height="150" alt="StepTo2D" />
                </Link>
              </li><br />

              <li>
                <Link to="/Parametricscrew">
                  <img src={sw} className="app-img" width="230" height="150" alt="Screw" />
                </Link>
              </li><br />
              <li>
                <Link to="/Nuts">
                  <img src={nu} className="app-img" width="230" height="150" alt="Nuts" />
                </Link>
              </li><br />



            </ul>
          </nav>
        </div>
      </div>

      
      <br />
      <br />
      <br />
      <footer className="footer-section">
        <div className="container-4">
          <div className="nav-items"></div>
          <div className="text-6">&copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
}

export default Rosad;
